import Service from "../Service";

const resource = "user/";

export default {
  save(usr, requestID) {
    return Service.post(resource + "save", usr, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  copyAllow(usr, usrs, requestID) {
    return Service.post(resource + "copyallow", usrs, {
      params: { usrID: usr.UsrID, requestID: requestID },
    });
  },
  listActive(requestID) {
    return Service.get(resource + "listActive", {
      params: { requestID: requestID },
    });
  },
  invite(usr, requestID) {
    return Service.post(resource + "Invite", usr, {
      params: { requestID: requestID },
    });
  },
  saveSignature(usr, requestID) {
    return Service.post(resource + "saveSignature", usr, {
      params: { requestID: requestID },
    });
  },
  getUserInfo(usrID, requestID) {
    return Service.get(resource + "info", {
      params: { usrID: usrID, requestID: requestID },
    });
  },
};
